import { Component, ErrorInfo, ReactNode } from 'react';
import Raven from 'raven-js';

type ErrorBoundaryProps = {
  children?: ReactNode;
  fallbackContent: ReactNode;
};

type ErrorBoundaryState = {
  error: null | Error;
  errorInfo: null | ErrorInfo;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      errorInfo,
      error,
    });
    Raven.captureException(new Error('ui-tool-access error'), {
      level: 'error',
      extra: {
        error,
      },
    });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return this.props.fallbackContent || null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
